"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allMatcherContext = void 0;
function allMatcherContext() {
    return function allMatcher(runtimeAttr) {
        return runtimeAttr != null;
    };
}
exports.allMatcherContext = allMatcherContext;
